<template>
  <div
    class="summary-card summary-card-up-to-date"
    :class="[
      { selected, 'summary-card-interactive': interactive },
    ]"
    @click="interactive && handleClick()"
  >
    <div class="summary-card-header">
      <div class="summary-card-title-row">
        <DpplSvg
          class="summary-card-icon"
          :file-name="icon"
        />
        <span class="text-h3 summary-card-label">{{ cardTitle }}</span>
      </div>
    </div>
    <p class="summary-card-value text-darkest">
      {{ label }}
    </p>
    <div class="summary-card-progress-track">
      <div
        class="summary-card-progress-fill"
        :style="{ width: `${percentage}%` }"
      />
    </div>
  </div>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineProps({
  percentage: { type: Number, default: 0 },
  label: { type: String, required: true },
  cardTitle: { type: String, default: 'Up to date' },
  selected: { type: Boolean, default: false },
  interactive: { type: Boolean, default: true },
  icon: { type: String, default: 'summary-check-circle' },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>

<style lang="less" scoped>
.summary-card {
  position: relative;
  min-height: 136px;
  height: 100%;
  padding: 16px;
  border-radius: 6px;
  border: 1px solid;
  background: @white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.summary-card-interactive {
  cursor: pointer;
}

.summary-card-up-to-date {
  border-color: @teal-500;

  &.selected {
    background: @teal-100;
  }

  &.summary-card-interactive:hover {
    background: fade(@teal-100, 50%);
  }

  .summary-card-icon,
  .summary-card-label {
    color: @teal-500;
  }

  .summary-card-progress-track {
    box-shadow: inset 0 4px 4px 0 fade(@teal-500, 12%);
  }

  .summary-card-progress-fill {
    background: @teal-500;
  }
}

.summary-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
  min-height: 28px;
}

.summary-card-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.summary-card-icon {
  flex-shrink: 0;
  width: 16px;
  height: 16px;

  :deep(path) {
    fill: currentColor;
  }
}

.summary-card-label {
  flex: 1;
  line-height: 120%;
}

.summary-card-value {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 4px;
}

.summary-card-progress-track {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: @stroke-default;
  margin-bottom: 8px;
  overflow: hidden;
}

.summary-card-progress-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.2s ease;
}
</style>
